export default {
    methods: {
        async readNotifications(ids) {
            if (!Array.isArray(ids)) { ids = [ids]; }
            if (ids.length > 0) { await axios.put('/api/notifications', ids); }
        },
        getNotificationIcon(notification) {
            let type = notification.type.split('\\').pop();
            switch (type) {
                default:
                    return ['info', 'grey'];
            }
        },
        notificationClick(e, notification) {
            if (e.target.matches('a')) {
                this.readNotifications([notification.id]);
                switch (notification.data.action) {
                    case 'summary':
                        // if insurer, go to insurer quote summary. Otherwise, go to broker quote summary
                        let routeName = this.info.user.role.id == 3 ? 'underwrite-policy' : 'polciy-summary';
                        this.$router.push({name: routeName,
params: {id: notification.data.quote_id}});
                }
            }
        }
    }
};
